import React from "react"
import classNames from "classnames"
import { makeStyles } from "@material-ui/core/styles"
//import { isMobile } from "react-device-detect"

// material-ui components
import { Typography, List, ListItem } from "@material-ui/core"

// custome components
import Card from "src/components/Card/Card.js"
import CardBody from "src/components/Card/CardBody.js"
import CardHeader from "src/components/Card/CardHeader.js"
import CustomButton from "src/components/CustomButton"
import GridContainer from "src/components/Grid/GridContainer.js"
import GridItem from "src/components/Grid/GridItem.js"

import PropertyDetail from "../PropertyDetail"

import cardStyles from "src/assets/jss/material-kit-react/components/cardStyle.js"
import styles from "src/assets/jss/material-kit-react/views/ListingsView/sections/filteredPropertiesStyles.js"

const useFeaturedStyles = makeStyles(styles)
const useCardStyles = makeStyles(cardStyles)

const FilteredProperties = ({
  pageContent,
  globalState,
  properties,
  listingType,
  ...rest
}) => {
  const classes = useFeaturedStyles()
  const cardClasses = useCardStyles()

  const { headerText_page } = pageContent
  const getPropertyFromHash = properties => {
    if (!globalState.isBrowser) return null
    const address = decodeURIComponent(document.location.hash)
    var i = null
    properties.some((p, index) => {
      if (address === "#" + p.text_streetAddress) {
        return (i = index)
      }
    })
    return i
  }

  const [currentPropertyIndex, setCurrentPropertyIndex] = React.useState(
    getPropertyFromHash(properties)
  )

  const showPropertyDetail = i => {
    if (!globalState.isBrowser) return
    setCurrentPropertyIndex(i)

    if (
      document.location.hash !==
      "#" + encodeURIComponent(properties[i].text_streetAddress)
    ) {
      document.location.hash = encodeURIComponent(
        properties[i].text_streetAddress
      )
    } else {
      const rect = document
        .getElementsByClassName("image-gallery")[0]
        .getBoundingClientRect()
      window.scrollTo({
        top: rect.top + window.scrollY,
        behavior: "smooth",
      })
    }
  }

  return (
    <Card className={classes.filteredPropertiesWrapper}>
      <CardHeader color="primary">{headerText_page}</CardHeader>
      <CardBody
        className={classNames(
          "cardBody",
          classes.cardBody,
          cardClasses.cardBody
        )}
      >
        <GridContainer direction="column">
          <GridItem className={"filteredPropertiesContent-root"} xs={12}>
            {currentPropertyIndex !== null && (
              <PropertyDetail
                property={properties[currentPropertyIndex]}
                globalState={globalState}
                listingType={listingType}
                isRenovation={
                  properties[currentPropertyIndex].boolean_remodel !== null
                    ? properties[currentPropertyIndex].boolean_remodel
                    : false
                }
              />
            )}
            {properties && (
              <List className="filteredPropertiesList-root">
                {properties.map((p, i) => {
                  const photos =
                    listingType === "renovation" && p.media_remodelPhotos
                      ? p.media_remodelPhotos
                      : p.media_photos

                  if (!photos) return null
                  const img =
                    listingType === "renovation" && p.media_remodelPhotos
                      ? p.media_remodelPhotos[0]
                      : p.media_featuredImage
                      ? p.media_featuredImage
                      : photos[0]

                  return (
                    <ListItem key={i}>
                      <div className="listingThumbnail-root constrained-image-wrapper img-2x3">
                        <CustomButton
                          className="constrained-image"
                          style={{
                            backgroundImage: "url(" + img.file.url + ")",
                          }}
                          onClick={() => {
                            showPropertyDetail(i)
                          }}
                        />
                      </div>
                      <div className="propertyInfo-root">
                        <a
                          onClick={() => {
                            showPropertyDetail(i)
                          }}
                        >
                          <span className="propertyInfo_streetAddress">
                            {p.text_streetAddress}
                          </span>
                          <span className="propertyInfo_city">
                            &nbsp;|&nbsp;{p.text_city}
                          </span>
                        </a>
                        <a
                          className="propertyInfo-size"
                          onClick={() => {
                            showPropertyDetail(i)
                          }}
                        >
                          {p.text_bedrooms +
                            " Bd | " +
                            p.text_bathrooms +
                            " Bath"}
                        </a>
                      </div>
                    </ListItem>
                  )
                })}
              </List>
            )}
            {!properties && (
              <Typography variant="body1" gutterBottom>
                No Listings Found
              </Typography>
            )}
          </GridItem>
        </GridContainer>
      </CardBody>
    </Card>
  )
}

export default FilteredProperties
